import type { AdminGroup2 } from 'src/models/group2';

export interface AdminGroup2Response {
  id: number;
  parent_id: number;
  name: string;
  disp_order: number;
}

export type AdminGroup2IndexResponse = AdminGroup2Response[];

export interface AdminGroup2DestroyResponse extends AdminGroup2Response {
  group3s: number[];
}

export const toAdminGroup2 = (response: AdminGroup2Response): AdminGroup2 => ({
  id: response.id,
  parentId: response.parent_id,
  name: response.name,
  dispOrder: response.disp_order,
});
